import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#501213',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#F34D36',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    text: {
        primary: '#1E1D1B',
        dark: '#323232',
    },
    common: {
        black: '#231F20',
        white: '#fff',
        'faux-white': '#F4F4F4',
        'faux-black': '#231F20',
        banner: '#C7AA8C66',
        beige: '#C7AA8C',
    },
    shadow: {
        main: '#00000022',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#39BB2D' },
        }),
        mildCategory: augmentColor({
            color: { main: '#F97D00' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#FF0000' },
        }),
    },
};
